export var RoomProtocol;
(function (RoomProtocol) {
    RoomProtocol["Join"] = "room::join";
    RoomProtocol["Invite"] = "room::invite";
    RoomProtocol["Joined"] = "room::joined";
    RoomProtocol["Invited"] = "room::invited";
    RoomProtocol["Leave"] = "room::leave";
    RoomProtocol["Delete"] = "room::delete";
    RoomProtocol["Rename"] = "room::rename";
    RoomProtocol["Left"] = "room::left";
    RoomProtocol["Closed"] = "room::closed";
    RoomProtocol["CallMediaCheck"] = "call::mediaCheck";
    RoomProtocol["CloseFailed"] = "room::closeFailed";
    RoomProtocol["CloseUnauthorized"] = "room::closeUnauthorized";
    RoomProtocol["Kick"] = "room::kick";
    RoomProtocol["KickFailed"] = "room::kickFailed";
    RoomProtocol["KickUnauthorized"] = "room::kickUnauthorized";
    RoomProtocol["TextMessage"] = "room::text";
    RoomProtocol["TextMessageReceived"] = "message::received";
    RoomProtocol["TextMessageRead"] = "message::read";
    RoomProtocol["TextMessageFetchHistory"] = "message::history";
    RoomProtocol["MessageReact"] = "message::react";
    RoomProtocol["ListRooms"] = "room::list";
    RoomProtocol["StartCall"] = "room::startCall";
    RoomProtocol["TypingEvent"] = "room::typingEvent";
})(RoomProtocol || (RoomProtocol = {}));
export var RoomCallType;
(function (RoomCallType) {
    RoomCallType["Audio"] = "audio";
    RoomCallType["Video"] = "video";
})(RoomCallType || (RoomCallType = {}));
export var TypingEventType;
(function (TypingEventType) {
    TypingEventType["TypingStarted"] = "typingStarted";
    TypingEventType["TypingStopped"] = "typingStopped";
})(TypingEventType || (TypingEventType = {}));
export var ServerProtocol;
(function (ServerProtocol) {
    ServerProtocol["Greeting"] = "chat::hello";
    ServerProtocol["Ok"] = "chat::ok";
    ServerProtocol["Error"] = "chat::error";
    ServerProtocol["Warning"] = "chat::warning";
    ServerProtocol["Bye"] = "chat::bye";
})(ServerProtocol || (ServerProtocol = {}));
export var SocketProtocol;
(function (SocketProtocol) {
    SocketProtocol["Initialized"] = "socket::init";
    SocketProtocol["Connected"] = "socket::connected";
    SocketProtocol["Disconnected"] = "socket::disconnected";
    SocketProtocol["Error"] = "socket::error";
    SocketProtocol["Reconnected"] = "socket::reconnected";
    SocketProtocol["ReconnectionTimedOut"] = "socked::reconnectionTimedOut";
})(SocketProtocol || (SocketProtocol = {}));
export var AuthProtocol;
(function (AuthProtocol) {
    AuthProtocol["AuthStart"] = "chat::auth";
    AuthProtocol["AuthSuccess"] = "chat::authSuccess";
    AuthProtocol["AuthFailed"] = "chat::authFailed";
})(AuthProtocol || (AuthProtocol = {}));
